import React, { useState, useEffect } from 'react';
import { graphql } from 'gatsby';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Box, Typography, Grid, Icon, Button } from "@material-ui/core";
import withWidth from '@material-ui/core/withWidth';
import Layout from "../components/layout";
// import SEO from '../components/SEO'
import NotaCard from "../components/NotaCard";
import Link from 'gatsby-link';
import conferenciaBanner from '../assets/tags/CONF_SECCION.png';
import SEOCategory from '../components/SEOCategory';
import banner from '../assets/banners/agenda/bannner-internacionalismo.jpg';
import banner2 from '../assets/banners/agenda/bannner-internacionalismo-2.jpeg';
import banner3 from '../assets/banners/agenda/bannner-internacionalismo-3.jpeg';
import banner4 from '../assets/banners/agenda/bannner-internacionalismo-4.jpeg';
import banner5 from '../assets/banners/agenda/bannner-internacionalismo-5.jpeg';
import banner6 from '../assets/banners/agenda/bannner-internacionalismo-6.jpeg';
import banner7 from '../assets/banners/agenda/bannner-internacionalismo-7.jpeg';
import banner8 from '../assets/banners/agenda/bannner-internacionalismo-8.jpg';
import banner9 from '../assets/banners/agenda/bannner-internacionalismo-9.png';
import banner10 from '../assets/banners/agenda/bannner-internacionalismo-10.jpeg';
import banner11 from '../assets/banners/agenda/bannner-internacionalismo-11.jpeg';
import banner12 from '../assets/banners/agenda/bannner-internacionalismo-12.jpeg';
import banner13 from '../assets/banners/agenda/bannner-internacionalismo-13.jpeg';
import banner14 from '../assets/banners/agenda/bannner-internacionalismo-14.jpeg';
import banner15 from '../assets/banners/agenda/bannner-internacionalismo-15.jpeg';
import banner16 from '../assets/banners/agenda/bannner-internacionalismo-16.jpeg';
import banner17 from '../assets/banners/agenda/bannner-internacionalismo-17.png';
import VideoCard from "../components/VideoCarousel";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import internacionalismoSegundaEtapaData from '../assets/revistas/internacionalismo-segunda-etapa-edm.json';

const getPdfUrl = (num) =>
  internacionalismoSegundaEtapaData.find(item => item.nombre.includes(`-${num}.pdf`))?.url;

const useStyles = makeStyles(theme => ({
    boxContenedor:{
        position:'relative',
        textAlign:"center",
        margin:"2rem",
    },
    pageControls:{
        marginTop:"1rem",
        display:"flex",
        justifyContent:"center",
    },
    boxCenterControls:{
        width:"10rem",
        position:"relative",
    },
    infoControls:{
        width:"50%",
    },
    boxPrevPage:{
        position:"absolute",
        left:"0",
    },
    boxNextPage:{
        position:"absolute",
        right:"0",
        top:"0",
    },
    gridNotaItem:{
    },
    tagBanner:{
        width: 'auto',
        height: '17rem',
        [theme.breakpoints.down('md')]: {
            height: '13.5rem',
        },
        [theme.breakpoints.down('sm')]: {
            height: '11.5rem',
        },
        [theme.breakpoints.down('xs')]: {
            height: '5rem',
        },
    },
    responsiveGrid: {
      width: "90%",
      display: "grid",
      gridTemplateColumns: "1fr",
      gap: "1rem",
      [theme.breakpoints.up('md')]: {
        marginLeft:"auto",
        marginRight: "auto",
        gridTemplateColumns: "1fr 1fr 1fr",
      },
    },
    iframeContainer: {
      marginLeft: "-10px",
    },
    destacada: {
      marginTop: "1rem",
      marginBottom: "1rem",
    },
    videosContainer: {
      display: 'flex',
      justifyContent: "center",
      marginTop: "1rem",
      marginBottom: "1rem",
    },
    boxRevistaHeader: {
      backgroundColor:"#E5332A",
      marginTop:"2rem", 
      padding:"3rem 3.5rem", 
      display:"flex", 
      justifyContent: "space-between",
      [theme.breakpoints.down('sm')]: {
        padding:"1rem 1.5rem",
        marginTop:"1rem",
      },
    },
    boxRevistaListaLabel: {
      display:"flex",
      flexDirection:"column",
      [theme.breakpoints.up('sm')]: {
        gap:"2rem",
      },
    },
    labelRevistaBoldWhiteLittle: {
      color:"white",
      fontFamily:"FuturaBold",
      [theme.breakpoints.down('sm')]: {
        fontSize:"0.5rem",
      },
    },
    labelRevistaBoldBlack: {
      color:"black",
      fontSize:"3rem",
      fontFamily:"FuturaBold",
      lineHeight:"1.5rem",
      [theme.breakpoints.down('xl')]: {
        fontSize:"2rem",
        lineHeight:"1rem",
      },
      [theme.breakpoints.down('sm')]: {
        fontSize:"0.8rem",
      },

    },
    labelRevistaBoldWhite: {
      color:"white",
      fontSize:"4rem",
      fontFamily:"FuturaBold",
      lineHeight:"1.5rem",
      [theme.breakpoints.down('sm')]: {
        fontSize:"0.8rem",
      },
    },    
    labelRevistaBoldWhiteLittle: {
      color:"white",
      fontFamily:"FuturaBold",
      [theme.breakpoints.down('sm')]: {
        fontSize:"0.5rem",
        textAlign:'right'
      },
    },    
}));

function ListaNotas({notas, imgFluidDefault}) {
    const classes = useStyles();
    return(
        <Box className={classes.boxContenedor} >
            <Grid container spacing={2}>
            {
              notas.map(nota => (
                <Grid key={`listanotas-${(Math.random()*100)+1}`} item xs={12} md={4} className={classes.gridNotaItem} >
                    <NotaCard node={nota} imgFluidDefault={imgFluidDefault} />
                </Grid>
              ))
            }
            </Grid>
        </Box>
    );
}

function InternacionalismoHeader() {
  const classes = useStyles();
  return(
    <Box className={classes.boxRevistaHeader}>
      <Box className={classes.boxRevistaListaLabel}>
        <span className={classes.labelRevistaBoldWhite}>INTERNACIONALISMO N°1</span>
        <span className={classes.labelRevistaBoldBlack}>Segunda época de En Defensa del Marxismo</span>
      </Box>
      <Box className={classes.boxRevistaListaLabel} style={{alignSelf:"center"}}>
        <span className={classes.labelRevistaBoldWhiteLittle}>Sábado 22 de noviembre de 2025</span>
      </Box>
    </Box>
  );
};

function Internacionalismo2Header() {
  const classes = useStyles();
  return(
    <Box className={classes.boxRevistaHeader}>
      <Box className={classes.boxRevistaListaLabel}>
        <span className={classes.labelRevistaBoldWhite}>INTERNACIONALISMO N°2</span>
        <span className={classes.labelRevistaBoldBlack}>Segunda época de En Defensa del Marxismo</span>
      </Box>
      <Box className={classes.boxRevistaListaLabel} style={{alignSelf:"center"}}>
        <span className={classes.labelRevistaBoldWhiteLittle}>Sábado 29 de noviembre de 2025</span>
      </Box>
    </Box>
  );
};

function Internacionalismo3Header() {
  const classes = useStyles();
  return(
    <Box className={classes.boxRevistaHeader}>
      <Box className={classes.boxRevistaListaLabel}>
        <span className={classes.labelRevistaBoldWhite}>INTERNACIONALISMO N°3</span>
        <span className={classes.labelRevistaBoldBlack}>Segunda época de En Defensa del Marxismo</span>
      </Box>
      <Box className={classes.boxRevistaListaLabel} style={{alignSelf:"center"}}>
        <span className={classes.labelRevistaBoldWhiteLittle}>Sábado 13 de diciembre de 2025</span>
      </Box>
    </Box>
  );
};

function Internacionalismo4Header() {
  const classes = useStyles();
  return(
    <Box className={classes.boxRevistaHeader}>
      <Box className={classes.boxRevistaListaLabel}>
        <span className={classes.labelRevistaBoldWhite}>INTERNACIONALISMO N°4</span>
        <span className={classes.labelRevistaBoldBlack}>Segunda época de En Defensa del Marxismo</span>
      </Box>
      <Box className={classes.boxRevistaListaLabel} style={{alignSelf:"center"}}>
        <span className={classes.labelRevistaBoldWhiteLittle}>Sábado 27 de diciembre de 2025</span>
      </Box>
    </Box>
  );
};

function Internacionalismo5Header() {
  const classes = useStyles();
  return(
    <Box className={classes.boxRevistaHeader}>
      <Box className={classes.boxRevistaListaLabel}>
        <span className={classes.labelRevistaBoldWhite}>INTERNACIONALISMO N°5</span>
        <span className={classes.labelRevistaBoldBlack}>Segunda época de En Defensa del Marxismo</span>
      </Box>
      <Box className={classes.boxRevistaListaLabel} style={{alignSelf:"center"}}>
        <span className={classes.labelRevistaBoldWhiteLittle}>Sábado 10 de enero de 2026</span>
      </Box>
    </Box>
  );
};

function Internacionalismo6Header() {
  const classes = useStyles();
  return(
    <Box className={classes.boxRevistaHeader}>
      <Box className={classes.boxRevistaListaLabel}>
        <span className={classes.labelRevistaBoldWhite}>INTERNACIONALISMO N°6</span>
        <span className={classes.labelRevistaBoldBlack}>Segunda época de En Defensa del Marxismo</span>
      </Box>
      <Box className={classes.boxRevistaListaLabel} style={{alignSelf:"center"}}>
        <span className={classes.labelRevistaBoldWhiteLittle}>Sábado 24 de enero de 2026</span>
      </Box>
    </Box>
  );
};

function Internacionalismo7Header() {
  const classes = useStyles();
  return(
    <Box className={classes.boxRevistaHeader}>
      <Box className={classes.boxRevistaListaLabel}>
        <span className={classes.labelRevistaBoldWhite}>INTERNACIONALISMO N°7</span>
        <span className={classes.labelRevistaBoldBlack}>Segunda época de En Defensa del Marxismo</span>
      </Box>
      <Box className={classes.boxRevistaListaLabel} style={{alignSelf:"center"}}>
        <span className={classes.labelRevistaBoldWhiteLittle}>Sábado 7 de febrero de 2026</span>
      </Box>
    </Box>
  );
};

function Internacionalismo8Header() {
  const classes = useStyles();
  return(
    <Box className={classes.boxRevistaHeader}>
      <Box className={classes.boxRevistaListaLabel}>
        <span className={classes.labelRevistaBoldWhite}>INTERNACIONALISMO N°8</span>
        <span className={classes.labelRevistaBoldBlack}>Segunda época de En Defensa del Marxismo</span>
      </Box>
      <Box className={classes.boxRevistaListaLabel} style={{alignSelf:"center"}}>
        <span className={classes.labelRevistaBoldWhiteLittle}>Sábado 28 de febrero de 2026</span>
      </Box>
    </Box>
  );
};

function Internacionalismo9Header() {
  const classes = useStyles();
  return(
    <Box className={classes.boxRevistaHeader}>
      <Box className={classes.boxRevistaListaLabel}>
        <span className={classes.labelRevistaBoldWhite}>INTERNACIONALISMO N°9</span>
        <span className={classes.labelRevistaBoldBlack}>Segunda época de En Defensa del Marxismo</span>
      </Box>
      <Box className={classes.boxRevistaListaLabel} style={{alignSelf:"center"}}>
        <span className={classes.labelRevistaBoldWhiteLittle}>Sábado 14 de marzo de 2026</span>
      </Box>
    </Box>
  );
};

function Internacionalismo10Header() {
  const classes = useStyles();
  return(
    <Box className={classes.boxRevistaHeader}>
      <Box className={classes.boxRevistaListaLabel}>
        <span className={classes.labelRevistaBoldWhite}>INTERNACIONALISMO N°10</span>
        <span className={classes.labelRevistaBoldBlack}>Segunda época de En Defensa del Marxismo</span>
      </Box>
      <Box className={classes.boxRevistaListaLabel} style={{alignSelf:"center"}}>
        <span className={classes.labelRevistaBoldWhiteLittle}>Sábado 28 de marzo de 2026</span>
      </Box>
    </Box>
  );
};

function Internacionalismo11Header() {
  const classes = useStyles();
  return(
    <Box className={classes.boxRevistaHeader}>
      <Box className={classes.boxRevistaListaLabel}>
        <span className={classes.labelRevistaBoldWhite}>INTERNACIONALISMO N°11</span>
        <span className={classes.labelRevistaBoldBlack}>Segunda época de En Defensa del Marxismo</span>
      </Box>
      <Box className={classes.boxRevistaListaLabel} style={{alignSelf:"center"}}>
        <span className={classes.labelRevistaBoldWhiteLittle}>Sábado 04 de abril de 2026</span>
      </Box>
    </Box>
  );
};

function Internacionalismo12Header() {
  const classes = useStyles();
  return(
    <Box className={classes.boxRevistaHeader}>
      <Box className={classes.boxRevistaListaLabel}>
        <span className={classes.labelRevistaBoldWhite}>INTERNACIONALISMO N°12</span>
        <span className={classes.labelRevistaBoldBlack}>Segunda época de En Defensa del Marxismo</span>
      </Box>
      <Box className={classes.boxRevistaListaLabel} style={{alignSelf:"center"}}>
        <span className={classes.labelRevistaBoldWhiteLittle}>Miércoles 01 de julio de 2026</span>
      </Box>
    </Box>
  );
};

function Internacionalismo13Header() {
  const classes = useStyles();
  return(
    <Box className={classes.boxRevistaHeader}>
      <Box className={classes.boxRevistaListaLabel}>
        <span className={classes.labelRevistaBoldWhite}>INTERNACIONALISMO N°13</span>
        <span className={classes.labelRevistaBoldBlack}>Segunda época de En Defensa del Marxismo</span>
      </Box>
      <Box className={classes.boxRevistaListaLabel} style={{alignSelf:"center"}}>
        <span className={classes.labelRevistaBoldWhiteLittle}>Sábado 25 de julio de 2026</span>
      </Box>
    </Box>
  );
};

function Internacionalismo14Header() {
  const classes = useStyles();
  return(
    <Box className={classes.boxRevistaHeader}>
      <Box className={classes.boxRevistaListaLabel}>
        <span className={classes.labelRevistaBoldWhite}>INTERNACIONALISMO N°14</span>
        <span className={classes.labelRevistaBoldBlack}>Segunda época de En Defensa del Marxismo</span>
      </Box>
      <Box className={classes.boxRevistaListaLabel} style={{alignSelf:"center"}}>
        <span className={classes.labelRevistaBoldWhiteLittle}>Sábado 01 de agosto de 2026</span>
      </Box>
    </Box>
  );
};

function Internacionalismo15Header() {
  const classes = useStyles();
  return(
    <Box className={classes.boxRevistaHeader}>
      <Box className={classes.boxRevistaListaLabel}>
        <span className={classes.labelRevistaBoldWhite}>INTERNACIONALISMO N°15</span>
        <span className={classes.labelRevistaBoldBlack}>Segunda época de En Defensa del Marxismo</span>
      </Box>
      <Box className={classes.boxRevistaListaLabel} style={{alignSelf:"center"}}>
        <span className={classes.labelRevistaBoldWhiteLittle}>Viernes 21 de agosto de 2026</span>
      </Box>
    </Box>
  );
};

function Internacionalismo16Header() {
  const classes = useStyles();
  return(
    <Box className={classes.boxRevistaHeader}>
      <Box className={classes.boxRevistaListaLabel}>
        <span className={classes.labelRevistaBoldWhite}>INTERNACIONALISMO N°16</span>
        <span className={classes.labelRevistaBoldBlack}>Segunda época de En Defensa del Marxismo</span>
      </Box>
      <Box className={classes.boxRevistaListaLabel} style={{alignSelf:"center"}}>
        <span className={classes.labelRevistaBoldWhiteLittle}>Viernes 19 de septiembre de 2026</span>
      </Box>
    </Box>
  );
};

function Internacionalismo17Header() {
  const classes = useStyles();
  return(
    <Box className={classes.boxRevistaHeader}>
      <Box className={classes.boxRevistaListaLabel}>
        <span className={classes.labelRevistaBoldWhite}>INTERNACIONALISMO N°17</span>
        <span className={classes.labelRevistaBoldBlack}>Segunda época de En Defensa del Marxismo</span>
      </Box>
      <Box className={classes.boxRevistaListaLabel} style={{alignSelf:"center"}}>
        <span className={classes.labelRevistaBoldWhiteLittle}>Sábado 10 de octubre de 2026</span>
      </Box>
    </Box>
  );
};

function EncabezadoPage({titulo}) {
    const classes = useStyles();
    switch (titulo) {
      case "bancarrota-politica-fitu":
        return(
          <Box>
            <Box className={classes.boxContenedor}>
              <Typography component="h1">
                <b>{`La bancarrota política del FITU`}</b>
              </Typography>
            </Box>
          </Box>
        )         
      case "pts-manifiesto-nacional-popular":
        return(
          <Box>
            <Box className={classes.boxContenedor}>
              <Typography component="h1">
                <b>{`PTS: un "Manifiesto" ´nacional y popular´`}</b>
              </Typography>
            </Box>
          </Box>
        )      
      case "segundo-congreso-nacional-politica-obrera":
        return(
          <Box>
            <Box className={classes.boxContenedor}>
              <Typography component="h1">
                <b>{`Segundo Congreso Nacional de Política Obrera`}</b>
              </Typography>
            </Box>
          </Box>
        )
      case "iv-congreso-politica-obrera":
        return(
          <Box>
            <Box className={classes.boxContenedor}>
              <Typography component="h1">
                <b>{`IV Congreso Nacional de Política Obrera`}</b>
              </Typography>
            </Box>
          </Box>
        )
      case "guerra-mundial-documentacion":
        return(
          <Box>
            <Box className={classes.boxContenedor}>
              <Typography component="h1">
                <b>{`La Guerra Mundial - Documentación`}</b>
              </Typography>
            </Box>
          </Box>
        )
      case "Segunda Conferencia Nacional":
        return(
          <Box>
            <Box className={classes.boxContenedor}>
              <Box style={{ display: 'flex', justifyContent: 'center' }}>
                <img className={classes.tagBanner} src={conferenciaBanner} alt="Segunda Conferencia Nacional Partido Obrero Tendencia" />    
              </Box>
            </Box>
          </Box>
        )
      case "Primer Congreso Política Obrera":
        return(
          <Box>
            <Box className={classes.boxContenedor}>
              <Typography component="h1">
                <b>{`Primer Congreso de Política Obrera (Partido Obrero Tendencia)`}</b>
              </Typography>
            </Box>
          </Box>
        )
      case "iii-evento-trotsky":
        return(
          <Box>
            <Box className={classes.boxContenedor}>
              <Typography variant='h4'>
                <b>{`III Evento León Trotsky | Buenos Aires 2024`}</b>
              </Typography>
            </Box>
          </Box>
        )
      case "internacionalismo-nro1":
        return(
          <InternacionalismoHeader />
        )
      case "internacionalismo-nro2":
        return(
          <Internacionalismo2Header />
        )
      case "internacionalismo-nro3":
        return(
          <Internacionalismo3Header />
        )
      case "internacionalismo-nro4":
        return(
          <Internacionalismo4Header />
        )
      case "internacionalismo-nro5":
        return(
          <Internacionalismo5Header />
        )
      case "internacionalismo-nro6":
        return(
          <Internacionalismo6Header />
        )
      case "internacionalismo-nro7":
        return(
          <Internacionalismo7Header />
        )
      case "internacionalismo-nro8":
        return(
          <Internacionalismo8Header />
        )
      case "internacionalismo-nro9":
        return(
          <Internacionalismo9Header />
        )
      case "internacionalismo-nro10":
        return(
          <Internacionalismo10Header />
        )
      case "internacionalismo-nro11":
        return(
          <Internacionalismo11Header />
        )
      case "internacionalismo-nro12":
        return(
          <Internacionalismo12Header />
        )
      case "internacionalismo-nro13":
        return(
          <Internacionalismo13Header />
        )
      case "internacionalismo-nro14":
        return(
          <Internacionalismo14Header />
        )
      case "internacionalismo-nro15":
        return(
          <Internacionalismo15Header />
        )          
      case "internacionalismo-nro16":
        return(
          <Internacionalismo16Header />
        )
      case "internacionalismo-nro17":
        return(
          <Internacionalismo17Header />
        )                                       
      default:
        return(
          <Box>
            <Box className={classes.boxContenedor}>
              <Typography component="h1" style={{fontSize:"2rem"}}>
                {/* TODO: REVISAR ESTO */}
                <b>{titulo.replace('"','').replace('-',' ')}</b>
              </Typography>
            </Box>
          </Box>
        )
    }
}

function Paginado({currentPage, numPages, tagSlug}) {
    const classes = useStyles();
    return(
        <Box className={classes.boxContenedor} >
            <Box className={classes.pageControls}>
                <Box className={classes.boxCenterControls}>
                    {currentPage > 1
                        &&  <Box className={classes.boxPrevPage}>
                                <Link
                                    to={`/tag/${tagSlug}/${(currentPage - 1) > 1 ? currentPage - 1 : ''}`}>
                                    <Icon>keyboard_arrow_left</Icon>
                                </Link>
                            </Box>
                    }
                    <Typography className={classes.infoControls} component="span">
                        <b>{`${currentPage}/${numPages}`}</b>
                    </Typography>
                    {currentPage < numPages
                        &&  <Box className={classes.boxNextPage}>
                                <Link
                                    to={`/tag/${tagSlug}/${currentPage + 1}`}
                                >
                                    <Icon>keyboard_arrow_right</Icon>
                                </Link>
                            </Box>
                    }
                </Box>
            </Box>
        </Box>
    );
}

function InfiniteScroll({items, currentPage, numPages, tagSlug, imgFluidDefault}) {
    // cargamos de a 6 elementos
    const [ hasMore, setMore ] = useState(items.length > 6)
    const [ currentList, setCurrentList ] = useState([...items.slice(0, 6)])

    const loadEdges = () => {
      const currentLength = currentList.length
      const more = currentLength < items.length
      const nextEdges = more ? items.slice(currentLength, currentLength + 6) : []
      setMore(more)
      setCurrentList([...currentList, ...nextEdges])
    }


    useEffect(() => {
        const handleScroll = () => {
          if ( !hasMore ) return;
          if ( window.innerHeight + document.documentElement.scrollTop >= (document.documentElement.offsetHeight - 5) ){
            loadEdges();
          }
        }
        window.addEventListener('scroll', handleScroll)
      return () => {
        window.removeEventListener('scroll', handleScroll)
      }
    });

    return (
      <>
        <ListaNotas notas={currentList} imgFluidDefault={imgFluidDefault} />
        {
          !hasMore &&
            <Paginado
                tagSlug={tagSlug}
                numPages={numPages}
                currentPage={currentPage}
            />
        }
        {
          hasMore &&
            <div>Escrollea hacia abajo para cargar mas...</div>
        }
      </>
    )
  }

  const videos = [
    {
      link:'https://www.youtube.com/embed/tuBb2XXS9Fs',
      title:'Por qué llaman a votar en blanco Parte 1',
    },
    {
      link:'https://www.youtube.com/embed/BTu1SbvfuWY',
      title:'Por qué llaman a votar en blanco Parte 2',
    },
    {
      link:'https://www.youtube.com/embed/vUcJraKJGkw',
      title:'Por qué llaman a votar en blanco Parte 3',
    },
    {
      link:'https://www.youtube.com/embed/dI3Ex4AvR4o',
      title:'Por qué llaman a votar en blanco Parte 4',
    },
  ]

function Tag(props) {
    const classes = useStyles();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));
    const notas = props.data.allMarkdownRemark.edges.map(item => item.node);
    const imgFluidDefault = props.data.file.childImageSharp.fluid;
    const { tag, numPages, currentPage, tagSlug } = props.pageContext;
    const notaDestacada = tagSlug === "voto-en-blanco" ? notas?.filter((item) => item.fields.slug === "10572-voto-en-blanco-no-solo-principista-sino-estrategico")[0] : null

    return (
        <Layout>
            <SEOCategory category={tag} slug={tagSlug} tag={true}/>
            <EncabezadoPage
                titulo={tag}
            />
            {
              tagSlug === "voto-en-blanco" && (
                <div style={{display: "flex", width: "100%"}}>
                  <div style={{backgroundColor: "lightgray"}}>
                    <div className={classes.responsiveGrid}>
                      <div className={classes.videosContainer}>
                        {/* <img
                          src={bannerAgenda}
                          style={{width: "400px"}}
                          alt="Acto: La izquierda verdadera vota en blanco! Hablan Jorge Altamira y Patricia Urones. Salón La Argentina. Rodriguez Peña 361, CABA"
                        /> */}
                      </div>
                      <div className={classes.iframeContainer}>
                        <VideoCard 
                          data={videos}
                        />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notaDestacada}/>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }
            {
              tagSlug === "internacionalismo-nro1" && (
                <>
                  <div style={{display: 'flex', justifyContent: 'center', padding: '2rem'}}>
                    <a href={getPdfUrl(1)} download>
                      <Button variant='contained'>Descargar PDF</Button>
                    </a>
                  </div>
                  <div style={{display: "flex", width: "100%", justifyContent: 'center'}}>
                    <div className={classes.responsiveGrid}>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[2]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[1]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[0]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[3]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[4]} />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'center'}}>
                      
                      <a key="internacionalismo" target="_blank" rel="noopener norefferer" href="https://politicaobrera.com/tag/internacionalismo-nro2/">
                        <div style={{position: 'relative', width: 'fit-content'}}>
                          <img
                            style={{width: !matches ? '900px' : '350px'}}
                            src={banner2} alt="Revista Internacionalismo (Segunda época EDM) Nro 2"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                </>
              )
            }
            {
              tagSlug === "internacionalismo-nro2" && (
                <>
                  <div style={{display: 'flex', justifyContent: 'center', padding: '2rem'}}>
                    <a href={getPdfUrl(2)} download>
                      <Button variant='contained'>Descargar PDF</Button>
                    </a>
                  </div>                
                  <div style={{display: "flex", width: "100%", justifyContent: 'center'}}>
                    <div className={classes.responsiveGrid}>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[3]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[1]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[4]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[0]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[2]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[5]} />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'center'}}>
                      
                      <a key="internacionalismo" target="_blank" rel="noopener norefferer" href="https://politicaobrera.com/tag/internacionalismo-nro3/">
                        <div style={{position: 'relative', width: 'fit-content'}}>
                          <img
                            style={{width: !matches ? '900px' : '350px'}}
                            src={banner3} alt="Revista Internacionalismo (Segunda época EDM) Nro 3"
                          />
                        </div>
                      </a>
                    </div>
                  </div>                  
                </>
              )
            }
            {
              tagSlug === "internacionalismo-nro3" && (
                <>
                  <div style={{display: 'flex', justifyContent: 'center', padding: '2rem'}}>
                    <a href={getPdfUrl(3)} download>
                    <Button variant='contained'>Descargar PDF</Button>
                    </a>
                  </div>                
                  <div style={{display: "flex", width: "100%", justifyContent: 'center'}}>
                    <div className={classes.responsiveGrid}>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[6]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[5]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[4]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[0]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[3]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[2]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[1]} />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'center'}}>
                      
                      <a key="internacionalismo" target="_blank" rel="noopener norefferer" href="https://politicaobrera.com/tag/internacionalismo-nro4/">
                        <div style={{position: 'relative', width: 'fit-content'}}>
                          <img
                            style={{width: !matches ? '900px' : '350px'}}
                            src={banner4} alt="Revista Internacionalismo (Segunda época EDM) Nro 4"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                </>
              )
            }
            {
              tagSlug === "internacionalismo-nro4" && (
                <>
                  <div style={{display: 'flex', justifyContent: 'center', padding: '2rem'}}>
                    <a href={getPdfUrl(4)} download>
                    <Button variant='contained'>Descargar PDF</Button>
                    </a>
                  </div>                
                  <div style={{display: "flex", width: "100%", justifyContent: 'center'}}>
                    <div className={classes.responsiveGrid}>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[5]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[3]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[4]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[2]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[1]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[0]} />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'center'}}>
                      <a key="internacionalismo" target="_blank" rel="noopener norefferer" href="https://politicaobrera.com/tag/internacionalismo-nro5/">
                        <div style={{position: 'relative', width: 'fit-content'}}>
                          <img
                            style={{width: !matches ? '900px' : '350px'}}
                            src={banner5} alt="Revista Internacionalismo (Segunda época EDM) Nro 5"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                </>
              )
            }
            {
              tagSlug === "internacionalismo-nro5" && (
                <>
                  <div style={{display: 'flex', justifyContent: 'center', padding: '2rem'}}>
                    <a href={getPdfUrl(5)} download>
                    <Button variant='contained'>Descargar PDF</Button>
                    </a>
                  </div>
                  <div style={{display: "flex", width: "100%", justifyContent: 'center'}}>
                    <div className={classes.responsiveGrid}>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[5]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[6]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[7]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[8]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[1]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[3]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[0]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[2]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[4]} />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'center'}}>
                      <a key="internacionalismo" target="_blank" rel="noopener norefferer" href="https://politicaobrera.com/tag/internacionalismo-nro6/">
                        <div style={{position: 'relative', width: 'fit-content'}}>
                          <img
                            style={{width: !matches ? '900px' : '350px'}}
                            src={banner6} alt="Revista Internacionalismo (Segunda época EDM) Nro 6"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                </>
              )
            }            
            {
              tagSlug === "internacionalismo-nro6" && (
                <>
                  <div style={{display: 'flex', justifyContent: 'center', padding: '2rem'}}>
                    <a href={getPdfUrl(6)} download>
                      <Button variant='contained'>Descargar PDF</Button>
                    </a>
                  </div>
                  <div style={{display: "flex", width: "100%", justifyContent: 'center'}}>
                    <div className={classes.responsiveGrid}>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[4]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[5]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[3]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[2]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[0]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[1]} />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'center'}}>
                      <a key="internacionalismo" target="_blank" rel="noopener norefferer" href="https://politicaobrera.com/tag/internacionalismo-nro7/">
                        <div style={{position: 'relative', width: 'fit-content'}}>
                          <img
                            style={{width: !matches ? '900px' : '350px'}}
                            src={banner7} alt="Revista Internacionalismo (Segunda época EDM) Nro 7"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                </>
              )
            }
            {
              tagSlug === "internacionalismo-nro7" && (
                <>
                  <div style={{display: 'flex', justifyContent: 'center', padding: '2rem'}}>
                    <a href={getPdfUrl(7)} download>
                      <Button variant='contained'>Descargar PDF</Button>
                    </a>
                  </div>
                  <div style={{display: "flex", width: "100%", justifyContent: 'center'}}>
                    <div className={classes.responsiveGrid}>                     
                      <div className={classes.destacada}>
                        <NotaCard node={notas[4]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[1]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[2]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[3]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[0]} />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'center'}}>
                      <a key="internacionalismo" target="_blank" rel="noopener norefferer" href="https://politicaobrera.com/tag/internacionalismo-nro8/">
                        <div style={{position: 'relative', width: 'fit-content'}}>
                          <img
                            style={{width: !matches ? '900px' : '350px'}}
                            src={banner8} alt="Revista Internacionalismo (Segunda época EDM) Nro 8"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                </>
              )
            }
            {
              tagSlug === "internacionalismo-nro8" && (
                <>
                  <div style={{display: 'flex', justifyContent: 'center', padding: '2rem'}}>
                    <a href={getPdfUrl(8)} download>
                      <Button variant='contained'>Descargar PDF</Button>
                    </a>
                  </div>
                  <div style={{display: "flex", width: "100%", justifyContent: 'center'}}>
                    <div className={classes.responsiveGrid}>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[1]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[0]} />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'center'}}>
                      <a key="internacionalismo" target="_blank" rel="noopener norefferer" href="https://politicaobrera.com/tag/internacionalismo-nro9/">
                        <div style={{position: 'relative', width: 'fit-content'}}>
                          <img
                            style={{width: !matches ? '900px' : '350px'}}
                            src={banner9} alt="Revista Internacionalismo (Segunda época EDM) Nro 9"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                </>
              )
            }
            {
              tagSlug === "internacionalismo-nro9" && (
                <>
                  <div style={{display: 'flex', justifyContent: 'center', padding: '2rem'}}>
                    <a href={getPdfUrl(9)} download>
                      <Button variant='contained'>Descargar PDF</Button>
                    </a>
                  </div>
                  <div style={{display: "flex", width: "100%", justifyContent: 'center'}}>
                    <div className={classes.responsiveGrid}>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[0]} />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'center'}}>
                      <a key="internacionalismo" target="_blank" rel="noopener norefferer" href="https://politicaobrera.com/tag/internacionalismo-nro10/">
                        <div style={{position: 'relative', width: 'fit-content'}}>
                          <img
                            style={{width: !matches ? '900px' : '350px'}}
                            src={banner10} alt="Revista Internacionalismo (Segunda época EDM) Nro 10"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                </>
              )
            }
            {
              tagSlug === "internacionalismo-nro10" && (
                <>
                  <div style={{display: 'flex', justifyContent: 'center', padding: '2rem'}}>
                    <a href={getPdfUrl(10)} download>
                      <Button variant='contained'>Descargar PDF</Button>
                    </a>
                  </div>
                  <div style={{display: "flex", width: "100%", justifyContent: 'center'}}>
                    <div className={classes.responsiveGrid}>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[0]} />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'center'}}>
                      <a key="internacionalismo" target="_blank" rel="noopener norefferer" href="https://politicaobrera.com/tag/internacionalismo-nro11/">
                        <div style={{position: 'relative', width: 'fit-content'}}>
                          <img
                            style={{width: !matches ? '900px' : '350px'}}
                            src={banner11} alt="Revista Internacionalismo (Segunda época EDM) Nro 11"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                </>
              )
            }
            {
              tagSlug === "internacionalismo-nro11" && (
                <>
                  <div style={{display: 'flex', justifyContent: 'center', padding: '2rem'}}>
                    <a href={getPdfUrl(11)} download>
                      <Button variant='contained'>Descargar PDF</Button>
                    </a>
                  </div>
                  <div style={{display: "flex", width: "100%", justifyContent: 'center'}}>
                    <div className={classes.responsiveGrid}>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[0]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[1]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[3]} />
                      </div>                                            
                      <div className={classes.destacada}>
                        <NotaCard node={notas[2]} />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'center'}}>
                      <a key="internacionalismo" target="_blank" rel="noopener norefferer" href="https://politicaobrera.com/tag/internacionalismo-nro12/">
                        <div style={{position: 'relative', width: 'fit-content'}}>
                          <img
                            style={{width: !matches ? '900px' : '350px'}}
                            src={banner12} alt="Revista Internacionalismo (Segunda época EDM) Nro 12"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                </>
              )
            }
            {
              tagSlug === "internacionalismo-nro12" && (
                <>
                  <div style={{display: 'flex', justifyContent: 'center', padding: '2rem'}}>
                    <a href={getPdfUrl(12)} download>
                      <Button variant='contained'>Descargar PDF</Button>
                    </a>
                  </div>
                  <div style={{display: "flex", width: "100%", justifyContent: 'center'}}>
                    <div className={classes.responsiveGrid}>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[0]} />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'center'}}>
                      <a key="internacionalismo" target="_blank" rel="noopener norefferer" href="https://politicaobrera.com/tag/internacionalismo-nro13/">
                        <div style={{position: 'relative', width: 'fit-content'}}>
                          <img
                            style={{width: !matches ? '900px' : '350px'}}
                            src={banner13} alt="Revista Internacionalismo (Segunda época EDM) Nro 13"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                </>
              )
            }
            {
              tagSlug === "internacionalismo-nro13" && (
                <>
                  <div style={{display: 'flex', justifyContent: 'center', padding: '2rem'}}>
                    <a href={getPdfUrl(13)} download>
                      <Button variant='contained'>Descargar PDF</Button>
                    </a>
                  </div>
                  <div style={{display: "flex", width: "100%", justifyContent: 'center'}}>
                    <div className={classes.responsiveGrid}>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[0]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[1]} />
                      </div>             
                      <div className={classes.destacada}>
                        <NotaCard node={notas[2]} />
                      </div>              
                    </div>
                  </div>
                  <div>
                    <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'center'}}>
                      <a key="internacionalismo" target="_blank" rel="noopener norefferer" href="https://politicaobrera.com/tag/internacionalismo-nro14/">
                        <div style={{position: 'relative', width: 'fit-content'}}>
                          <img
                            style={{width: !matches ? '900px' : '350px'}}
                            src={banner14} alt="Revista Internacionalismo (Segunda época EDM) Nro 14"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                </>
              )
            }
            {
              tagSlug === "internacionalismo-nro14" && (
                <>
                  <div style={{display: 'flex', justifyContent: 'center', padding: '2rem'}}>
                    <a href={getPdfUrl(14)} download>
                      <Button variant='contained'>Descargar PDF</Button>
                    </a>
                  </div>
                  <div style={{display: "flex", width: "100%", justifyContent: 'center'}}>
                    <div className={classes.responsiveGrid}>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[0]} />
                      </div>           
                    </div>
                  </div>
                  <div>
                    <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'center'}}>
                      <a key="internacionalismo" target="_blank" rel="noopener norefferer" href="https://politicaobrera.com/tag/internacionalismo-nro15/">
                        <div style={{position: 'relative', width: 'fit-content'}}>
                          <img
                            style={{width: !matches ? '900px' : '350px'}}
                            src={banner15} alt="Revista Internacionalismo (Segunda época EDM) Nro 15"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                </>
              )
            }
            {
              tagSlug === "internacionalismo-nro15" && (
                <>
                  <div style={{display: 'flex', justifyContent: 'center', padding: '2rem'}}>
                    <a href={getPdfUrl(15)} download>
                      <Button variant='contained'>Descargar PDF</Button>
                    </a>
                  </div>
                  <div style={{display: "flex", width: "100%", justifyContent: 'center'}}>
                    <div className={classes.responsiveGrid}>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[0]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[1]} />
                      </div>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[2]} />
                      </div>                      
                    </div>
                  </div>
                  <div>
                    <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'center'}}>
                      <a key="internacionalismo" target="_blank" rel="noopener norefferer" href="https://politicaobrera.com/tag/internacionalismo-nro16/">
                        <div style={{position: 'relative', width: 'fit-content'}}>
                          <img
                            style={{width: !matches ? '900px' : '350px'}}
                            src={banner16} alt="Revista Internacionalismo (Segunda época EDM) Nro 16"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                </>
              )
            }
            {
              tagSlug === "internacionalismo-nro16" && (
                <>
                  {/* <div style={{display: 'flex', justifyContent: 'center', padding: '2rem'}}>
                    <a href={getPdfUrl(15)} download>
                      <Button variant='contained'>Descargar PDF</Button>
                    </a>
                  </div> */}
                  <div style={{display: "flex", width: "100%", justifyContent: 'center'}}>
                    <div className={classes.responsiveGrid}>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[0]} />
                      </div>                    
                    </div>
                  </div>
                  <div>
                    <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'center'}}>
                      <a key="internacionalismo" target="_blank" rel="noopener norefferer" href="https://politicaobrera.com/tag/internacionalismo-nro17/">
                        <div style={{position: 'relative', width: 'fit-content'}}>
                          <img
                            style={{width: !matches ? '900px' : '350px'}}
                            src={banner17} alt="Revista Internacionalismo (Segunda época EDM) Nro 17"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                </>
              )
            }
            {
              tagSlug === "internacionalismo-nro17" && (
                <>
                  {/* <div style={{display: 'flex', justifyContent: 'center', padding: '2rem'}}>
                    <a href={getPdfUrl(15)} download>
                      <Button variant='contained'>Descargar PDF</Button>
                    </a>
                  </div> */}
                  <div style={{display: "flex", width: "100%", justifyContent: 'center'}}>
                    <div className={classes.responsiveGrid}>
                      <div className={classes.destacada}>
                        <NotaCard node={notas[0]} />
                      </div>                    
                    </div>
                  </div>
                  <div>
                    <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'center'}}>
                      <a key="internacionalismo" target="_blank" rel="noopener norefferer" href="https://politicaobrera.com/tag/internacionalismo-nro1/">
                        <div style={{position: 'relative', width: 'fit-content'}}>
                          <img
                            style={{width: !matches ? '900px' : '350px'}}
                            src={banner} alt="Revista Internacionalismo (Segunda época EDM) Nro 1"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                </>
              )
            }            
            {notas.length > 0 && 
            tagSlug !== "internacionalismo-nro1" &&
            tagSlug !== "internacionalismo-nro2" &&
            tagSlug !== "internacionalismo-nro3" &&
            tagSlug !== "internacionalismo-nro4" &&
            tagSlug !== "internacionalismo-nro5" &&
            tagSlug !== "internacionalismo-nro6" &&
            tagSlug !== "internacionalismo-nro7" &&
            tagSlug !== "internacionalismo-nro8" &&
            tagSlug !== "internacionalismo-nro9" &&
            tagSlug !== "internacionalismo-nro10" &&
            tagSlug !== "internacionalismo-nro11" &&
            tagSlug !== "internacionalismo-nro12" &&
            tagSlug !== "internacionalismo-nro13" &&
            tagSlug !== "internacionalismo-nro14" &&
            tagSlug !== "internacionalismo-nro15" &&
            tagSlug !== "internacionalismo-nro16" &&
              <InfiniteScroll
                  items={notas}
                  imgFluidDefault={imgFluidDefault}
                  autorSlug={tagSlug}
                  numPages={numPages}
                  currentPage={currentPage}
              />
            }
            {notas.length === 0 && (
                <Box className={classes.boxContenedor} >
                    <Typography component="p">
                        <b>No hay notas por el momento para este tag.</b>
                    </Typography>
                </Box>
            )}
        </Layout>
    );
}


export const query = graphql`
    query($tag: String, $skip: Int, $limit: Int) {
        allMarkdownRemark(
            filter: {frontmatter: {tags: {eq: $tag}}}
            sort: { fields: [frontmatter___date], order: DESC }
            limit: $limit
            skip: $skip
        ){
            edges{
                node{
                    frontmatter {
                        title
                        image
                        author
                        date
                        seccion
                    }
                    fields {
                        slug
                    }
                }
            }
        }
        file(sourceInstanceName: {eq: "defaults"}) {
            childImageSharp {
                fluid(maxWidth: 300) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`;

export default withWidth()(Tag);
